import { createUrlResolver, siteNames } from '@seek/melways-sites';

import { SITE } from 'src/app/shared/constants/configObjectProperties';
import { useConfig } from 'src/app/shared/hooks/useConfig';
import { getConfig } from 'src/app/utils/config';
import { isStaging } from 'src/app/utils/environment';

export const useLocaliseRoute = () => {
  const { getLanguage } = useConfig();

  return createUrlResolver({
    site: getConfig(SITE, siteNames.employer.seek.au),
    language: getLanguage(),
    staging: isStaging(),
  });
};
